/* eslint-disable no-undef */
import { toast } from "react-toastify";
import { BASE_URL } from "./connectionUrl";

export const getActivity = async (
  token,
  q,
  page,
  per_page,
  start_date,
  end_date,
  itemId,
  entity_type
) => {
  const endpoint =
    `/api/v1/admin/activity?start_date=${start_date}&end_date=${end_date}&page=${page}&per_page=${per_page}` +
    (itemId ? `&item_id=${itemId}` : "") +
    (entity_type ? `&item_type=${entity_type}` : "") +
    (q ? `&event=${q}` : "");
  try {
    const response = await fetch(`${BASE_URL}${endpoint}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      },
    });

    const data = await response.json();
    if (data.status.status === "SUCCESS") {
      return data;
    } else {
      toast.error(data?.status?.message || "something went wrong");
    }
  } catch (error) {
    toast.error(error.message || "something went wrong");
  }
};
